import { Component, OnInit, NgZone, ViewChild, ElementRef } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormdataService } from '@services/formdata.service';
import { SaveService } from '@services/save.service';
import { FormBuilder, FormGroup,FormArray } from '@angular/forms';
import { CategoryService } from '@services/category.service';
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { ViewService } from '@services/view.service';
import { Helper } from '@category/helper';
import * as _ from 'lodash';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { CommonPipe } from '@pipes/common.pipe';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { AddService } from '@services/add.service';
import { SearchService } from '@services/search.service';
@Component({
  selector: 'app-eplay-list',
  templateUrl: './eplay-list.component.html',
  styleUrls: ['./eplay-list.component.sass']
})
export class EplayListComponent implements OnInit {
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'audio/*',
    clickable: true
  };
  public cconfig: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true
  };
  pathToMedia: any = {};
  myaudio_count=0;
  selected_audios:any=[];
  myaudio_loading=true;
  image_paths: any = [];
  btn_process = false;
  audios:any=[];
  autocomplete_load = false;
  params: any = [];
  audio_btn_process=false;
  appEditForm: FormGroup;
  audioListForm:FormGroup;
  application = "";
  country = "";
  component = "";
  category = "";
  privacy_list: any = [];
  error: any = { 'name': '', 'categoryJson': '' };
  selected_category = "";
  page_loading=true;
  id="";
  response:any=[];
  rows=15;
  pageCounter=1;
  audio_param=[];
  constructor(private _addService: AddService, private _searchService: SearchService, public ngxSmartModalService: NgxSmartModalService,private _cpipe: CommonPipe, private _viewService: ViewService, private _categoryService: CategoryService, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.rows = this._global.ROWS;
    this.application = "playList";
    this.appEditForm = this.fb.group({
      name: [],
      description: [],
      privacy: [],
      location: []
    });
    this.audioListForm = this.fb.group({
      list: new FormArray([])
    });
    this.route.queryParams.subscribe(params => {

      this.params = params;
      this.id = this.params['id'];
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            Object.entries(this.response['audio']).forEach(([key, value]) => {
              this.selected_audios.push(key);
            });

            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            this.image_paths.push(this.pathToMedia);
            this.page_loading = false;
            let THIS = this;
            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);
                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
            let f = {
              'component': this.component,
              'application': this.application
            };
            this._formdataService.common(f, 'mediaVisibility').subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  this.privacy_list = this._global.getVal(data, 'response', '');
                }
                this.appEditForm.get('privacy').setValue(this.response.privacy);
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
              let pa = {
                component: this.component,
                application: 'audio',
                start: 0,
                sortOrder: 'desc',
                sortString: 'createdTime',
                createdBy: this._global.getSessionVal('id'),
                rows: this.rows
              };
              this.loadMyAudio(pa);
          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });

  }
  @ViewChild('cover') public cover: ElementRef;
  ngOnInit(): void {
  }
  save() {
    this.error = { 'name': '', 'categoryJson': '' };
    this.btn_process = true;
    let r = this.appEditForm.value;
    r.component = this.component;
    r.application = this.application;
    r.setType = this.application;
    r.id=this.id;
    let p = this._global.paramsRemoveNull(r);
    p.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');
    p.pathToMedia = JSON.stringify(this.pathToMedia);
    this._saveService.appUpdate(p).subscribe(
      data => {

        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
          this.router.navigate(['/my/' + this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  public onCUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'cover', this.id);
  }
  public onCUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onCUploadSuccess(args: any): void {
    this.cover.nativeElement.src = this._cpipe.transform(this.response, ['image', 'cover', 'id', 'name', 'm']);
  }

  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, 'audio', '');
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);
    this.image_paths = [];
    this.image_paths.push(this.pathToMedia);
  }
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }
  returnZero() {
    return 0
  }
  audioEdit(obj){
    this.ngxSmartModalService.getModal('playaudioedit').open()
  }
  audioAdd() {
    this.audio_btn_process = true;
    let r = {};
    r['component'] = this.component;
    r['application'] = this.application;
    r['id'] = this.response.id;
    let ids = [];
    Object.entries(this.audioListForm.value['list']).forEach(([key, value]) => {
      if (value) {
        ids.push(this.audios[key]['id']);
      }
    });
    r['mediaIds'] = ids.join(",");
    r = this._global.paramsRemoveNull(r);
    this._addService.application(r).subscribe(
      data => {
        this.audio_btn_process = false;
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ type: severity, message: message });
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'warning';
          for (let key in data["errors"]) {
            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
          }
          this._global.showMessage({ type: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  loadMyAudio(pa) {
    this.myaudio_loading=true;
    this._searchService.memberApplication(pa).subscribe(
      data => {
        this.myaudio_loading=false;
        if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
          this.audios = this._global.getVal(data, "response.docs", []);
          this.audio_param = this._global.getVal(data, 'request', '');
          this.myaudio_count= this._global.getVal(data, 'response.numFound', '0');
          Object.entries(this.audios).forEach(([key, value]) => {
            let control = this.fb.control('');
            if (this.selected_audios.indexOf(value['id']) != -1) {
              control = this.fb.control(value['id']);
            }
            (this.audioListForm.controls.list as FormArray).push(control);
          });

        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  onScrollDown() {
    if (!this.myaudio_loading) {
      this.myaudio_loading = true;
      if (this.myaudio_count <= this.pageCounter * this.rows) {
        this.myaudio_loading = false;
      } else {
        let p = this._global.generateParams(this.audio_param, ['component', 'start', 'language', 'url', 'dialect']);
        p['start'] = this.pageCounter * this.rows;
        p['component'] = this.component;
        this._searchService.memberApplication(p).subscribe(
          data => {
            if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
              this.audios = this.audios.concat(data["response"]["docs"]);
              Object.entries(data["response"]["docs"]).forEach(([key, value]) => {
                let control = this.fb.control('');
                if (this.selected_audios.indexOf(value['id']) != -1) {
                  control = this.fb.control(value['id']);
                }
                (this.audioListForm.controls.list as FormArray).push(control);
              
              });
              this.myaudio_loading = false;
              this.pageCounter += 1;
              this.audio_param = this._global.getVal(data, 'request', '');
            } else {
              this.myaudio_loading = false;
            }
          },
          error => {
            console.log("error", JSON.stringify(error));
          });

      }
    }
  }
}
